export default function Marquee({ items, className = "" }) {
  const row = items.map((i) => i.toUpperCase()).join("  ·  ") + "  ·  ";
  return (
    <div
      className={`overflow-hidden border-y border-white/[0.08] py-4 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((k) => (
          <span
            key={k}
            aria-hidden={k === 1}
            className="font-display pr-6 text-base font-medium uppercase tracking-[0.22em] text-white/[0.16] md:text-xl"
          >
            {row.repeat(3)}
          </span>
        ))}
      </div>
    </div>
  );
}
